import React from 'react'
import QuestionnaireFormCodeEntry from './QuestionnaireFormCodeEntry'
import BaseMainPageLayout from '../Common/BaseMainPageLayout';
import * as Constants from '../Common/CommonConstants';


export default class CodeEntryBase extends BaseMainPageLayout {

    constructor(props){
        super(props);   
        this.questionnaireRef = React.createRef();
        this.state={formData:{}, formState: Constants.ENTER_KEY_MODE , key1:"", key2:"", doneMessage:"", doneSubMessage:"",  error: 0};
        
    }

    cancelText = ()=>this.state.formState===Constants.READ_ONLY_MODE? "Return to enter code screen": "Cancel";

    renderContentArea = () =>{
        if(this.state.formState===Constants.DONE_MODE)
            return this.renderDoneMessage();
        if (this.state.formState===Constants.ENTER_KEY_MODE)
            return this.renderKeyEntryDialog();

        
        return <QuestionnaireFormCodeEntry ref={this.questionnaireRef} directLoadedForm={this.state.formData} completed
            handleRefresh={()=>this.setCompleteState()} 
            readOnlyMode = {(this.state.formState===Constants.READ_ONLY_MODE)}
            key1={this.state.key1}
            key2={this.state.key2}
            {...this.props}/>
    }

    renderLoginMessage=()=>{
        if(this.state.formData && this.state.formData.userName)
        return(
            <div className="navbar-welcome">
                Welcome {this.state.formData.userName} !
            </div>
        );
    }
    
    renderDoneMessage=()=>{
        
        return(
            <div className="user-message-wrapper fadeInDown">
            <div className="login-form-content">
              <div  className="pcrb-logo"></div>
              <form>
                <h4 className="code-login-welcome">
                  {this.state.doneMessage}   
                  { this.state.doneSubMessage &&
                   <p>
                       {this.state.doneSubMessage}                  
                    </p>

                }               
                </h4>
                                
                <div style={{margin:"20px"}}>
                  Close browser tab or click <a href="http://www.pcrb.com">here</a> to visit the PCRB/DCRB home page
                </div>                            
              </form>
              
                or open the form again
                <br/>
                <br/>
                    {this.renderKeyEntryControl()}
            </div>
          </div>
        );
        
    }

    renderKeyEntryDialog = () => {

        return (
            <div className="user-message-wrapper fadeInDown">
                <div className="login-form-content">
                    <div  className="pcrb-logo"></div>
                    <h2 className="code-login-welcome">
                        Enter Access Code
                    </h2>
                    <h6 className="code-login-text">Please enter the Access Code that was provided in the PCRB/DCRB correspondence.  
                    This code will allow you to access the document specifically created for your organization. 
                        <br/>All code characters are letters (A-Z only)
                    </h6>
                    <br></br>
                    {this.renderKeyEntryControl()}
                </div>
            </div>
        );

    }

    renderKeyEntryControl = () =>{
        return(
        <div>
            <form className="form-inline" style={{"justifyContent":"center"}} >                        
            <input autoFocus value={this.state.key1} onChange={evt => this.setState({key1:evt.target.value})} className="form-control code-input-box"  />     
            <span style={{"margin":"8px"}}>-</span>
            <input value={this.state.key2} onChange={evt => this.setState({key2:evt.target.value})} className="form-control code-input-box"  />                     </form>
            <br></br>
            {this.state.error == "401" &&
            <div>
                <div className="code-login-error">The access code that you have entered is either incorrect or expired. Please check code, and try again or contact Central Support at centralsupport@pcrb.com</div>
                <br></br>
            </div>
            }
            {this.renderButton()}
            
        </div>);
    }
        
    navigateAway=(saveResult)=>{
       if(this.state.formState === Constants.READ_ONLY_MODE)
        this.setState({formState:Constants.DONE_MODE, doneMessage:"", doneSubMessage:""})
       else if(saveResult)
          this.setState({formState:Constants.DONE_MODE, doneMessage:"Form was not saved", doneSubMessage:""})
       else
          this.setState({formState:Constants.DONE_MODE, doneMessage:"Form Saved Successfully", doneSubMessage: "(but not completed)"})
    }

    setCompleteState=()=>{
        this.setState({formState:Constants.DONE_MODE, doneMessage:"Form Completed Successfully", doneSubMessage: ""})
    }

}






